import { render, staticRenderFns } from "./editFile.vue?vue&type=template&id=abf1127a&scoped=true"
import script from "./editFile.vue?vue&type=script&lang=js"
export * from "./editFile.vue?vue&type=script&lang=js"
import style0 from "./editFile.vue?vue&type=style&index=0&id=abf1127a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abf1127a",
  null
  
)

export default component.exports